// Ref: https://github.com/chakra-ui/chakra-ui/blob/main/packages/theme/src/components/form-label.ts

import { defineStyle, defineStyleConfig } from '@chakra-ui/styled-system';

const baseStyle = defineStyle({
    fontSize: 'sm',
    marginEnd: 3,
    mb: 3,
    fontWeight: 'medium',
    transitionProperty: 'common',
    transitionDuration: 'normal',
    opacity: 1,
    _disabled: {
        opacity: 0.4,
    },
    color: 'textMuted',
});

const formLabelTheme = defineStyleConfig({
    baseStyle,
});

export default formLabelTheme;
